/**
 * CourseCardSkeleton
 * Shimmer placeholder matching CourseCardPlayful's shape (glyph tile, title,
 * meta row, footer status + CTA), shown while courses load.
 */
import React from 'react';

const CourseCardSkeleton: React.FC = () => (
  <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-soft dark:border-secondary-700 dark:bg-secondary-800">
    <div className="flex items-start justify-between">
      <div className="h-12 w-12 animate-pulse rounded-xl bg-gray-200 dark:bg-secondary-700" />
      <div className="h-6 w-20 animate-pulse rounded-full bg-gray-100 dark:bg-secondary-700/60" />
    </div>
    <div className="mt-4 h-4 w-3/4 animate-pulse rounded-full bg-gray-200 dark:bg-secondary-700" />
    <div className="mt-2 h-3 w-full animate-pulse rounded-full bg-gray-100 dark:bg-secondary-700/60" />
    <div className="mt-1.5 h-3 w-2/3 animate-pulse rounded-full bg-gray-100 dark:bg-secondary-700/60" />
    <div className="mt-3 flex gap-4">
      <div className="h-3 w-20 animate-pulse rounded-full bg-gray-100 dark:bg-secondary-700/60" />
      <div className="h-3 w-24 animate-pulse rounded-full bg-gray-100 dark:bg-secondary-700/60" />
    </div>
    <div className="mt-4 flex items-center justify-between border-t border-gray-100 pt-4 dark:border-secondary-700">
      <div className="h-6 w-28 animate-pulse rounded-full bg-gray-100 dark:bg-secondary-700/60" />
      <div className="h-8 w-20 animate-pulse rounded-full bg-gray-200 dark:bg-secondary-700" />
    </div>
  </div>
);

export default CourseCardSkeleton;
